import * as React from 'react';
import { ComplexValue } from 'ui';
import { SelectSingle } from 'app/area/shared/translated-components';
import styles from './report-screen.scss';

interface SchedulePrimaryOwnerProps {
  scheduleOwner?: ComplexValue<number>;
  initialOwners?: ComplexValue<number>[];
  primaryOwnerLabel?: string;
  primaryOwnerInfoMessage?: string;
  primaryOwnerPlaceholder?: string;
}

export const SchedulePrimaryOwner = ({
  scheduleOwner, initialOwners = [], primaryOwnerLabel,
  primaryOwnerInfoMessage, primaryOwnerPlaceholder
}: SchedulePrimaryOwnerProps) => {

  const valueItem = initialOwners?.length === 1
    ? initialOwners?.[0]
    : scheduleOwner;

  return <div className={`${styles.scheduleRow}`}>
    <div className="col-sm-8 col-md-6">
      <SelectSingle
        componentId="primaryOwner"
        className=""
        label={{ text: primaryOwnerLabel }}
        info={{ visible: true, text: primaryOwnerInfoMessage }}
        valueItem={valueItem}
        options={initialOwners}
        placeholder={primaryOwnerPlaceholder}
        readOnly={true}
        onChange={() => undefined}
      />
    </div>
  </div>;
};
